import Application from "../../Application";
import { IInstitutionDetails } from "../../organisations/model/InstitutionDetails";
import { IOrganisation } from "../../organisations/model/Organisation";

import OrganisationDetailsHomePresenter, {
  IOrganisationDetailsHomePresenter
} from "../presenter/OrganisationDetailsHomePresenter";
import GetInstitutionDetailsInteractor from "../../organisations/interactors/GetOrganisationInstitutionDetailsInteractor";
import GetOrganisationInteractor from "../../organisations/interactors/GetOrganisationInteractor";
import GetAllOrganisationCaseLawDocumentsWithCategoriesInteractor from "./GetAllOrganisationCaseLawDocumentsWithCategoriesInteractor";
import GetAllOrganisationCaseDecisionTypesWithCategoriesInteractor from "./GetAllOrganisationCaseDecisionTypesWithCategoriesInteractor";
import GetAllOrganisationLegalViewTypesWithCategoriesInteractor from "./GetAllOrganisationLegalViewTypesWithCategoriesInteractor";

export default class ShowOrganisationDetailsHomeInteractor {
  private application: Application;
  private output?: IOrganisationDetailsHomePresenter;
  private getOrganisationInteractor: GetOrganisationInteractor;
  private getInstitutionDetailsInteractor: GetInstitutionDetailsInteractor;
  private getAllOrganisationCaseLawDocumentsWithCategoriesInteractor: GetAllOrganisationCaseLawDocumentsWithCategoriesInteractor;
  private getAllOrganisationCaseDecisionTypesWithCategoriesInteractor: GetAllOrganisationCaseDecisionTypesWithCategoriesInteractor;
  private getAllOrganisationLegalViewTypesWithCategoriesInteractor: GetAllOrganisationLegalViewTypesWithCategoriesInteractor;

  constructor({
    application,
    getOrganisation,
    getInstitutionDetails,
    getAllOrganisationCaseLawDocumentsWithCategories,
    getAllOrganisationCaseDecisionTypesWithCategories,
    getAllOrganisationLegalViewTypesWithCategories
  }) {
    this.application = application;
    this.getOrganisationInteractor = getOrganisation;
    this.getInstitutionDetailsInteractor = getInstitutionDetails;
    this.getAllOrganisationCaseLawDocumentsWithCategoriesInteractor =
      getAllOrganisationCaseLawDocumentsWithCategories;
    this.getAllOrganisationCaseDecisionTypesWithCategoriesInteractor =
      getAllOrganisationCaseDecisionTypesWithCategories;
    this.getAllOrganisationLegalViewTypesWithCategoriesInteractor =
      getAllOrganisationLegalViewTypesWithCategories;
  }

  private async getAllCaseLawDocumentTypes(organisationId) {
    return this.getAllOrganisationCaseLawDocumentsWithCategoriesInteractor.execute(
      organisationId
    );
  }
  private async getAllCaseDecisionTypes(organisationId) {
    return this.getAllOrganisationCaseDecisionTypesWithCategoriesInteractor.execute(
      organisationId
    );
  }
  private async getAllOrganisationLegalViewTypesWithCategories(organisationId) {
    return this.getAllOrganisationLegalViewTypesWithCategoriesInteractor.execute(
      organisationId
    );
  }
  private async getInstitutionDetails(organisationId) {
    return this.getInstitutionDetailsInteractor.execute(organisationId);
  }

  private async getReferenceLists(organisationId) {
    return Promise.all([
      this.getAllCaseLawDocumentTypes(organisationId),
      this.getAllCaseDecisionTypes(organisationId),
      this.getInstitutionDetails(organisationId),
      this.getAllOrganisationLegalViewTypesWithCategories(organisationId)
    ]);
  }

  execute(organisationId) {
    this.output = Object.assign(
      OrganisationDetailsHomePresenter({
        application: this.application,

        initialState: {
          organisation: {} as IOrganisation,
          institutionDetails: {} as IInstitutionDetails,
          caseLawDocumentTypes: [],
          caseDecisionTypes: [],
          legalViewTypes: []
        }
      })
    );

    this.getReferenceLists(organisationId).then(
      ([
        caseLawDocumentTypes,
        caseDecisionTypes,
        institutionDetails,
        legalViewTypes
      ]) =>
        this.output?.loadReferenceValues(
          caseLawDocumentTypes,
          caseDecisionTypes,
          institutionDetails,
          legalViewTypes
        )
    );
    this.getOrganisationInteractor
      .execute(organisationId)
      .then((organisation) => this.output?.loadOrganisation(organisation));

    return this.output;
  }
}
